module.exports = __webpack_public_path__ + "static/media/map_2x.ef686e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshots/map_2x.png
// module id = 144
// module chunks = 27